import "core-js/modules/es.array.push.js";
import { useAuthStore } from '@/store/auth';
import { useRouter } from 'vue-router';
export default {
  name: 'MembershipCard',
  setup() {
    const authStore = useAuthStore();
    const router = new useRouter();
    /**
     * 启动微信授权流程
     * 1. 设置前端回调地址为绑定页面
     * 2. 调用store中的授权方法
     */
    const startWechatAuth = () => {
      //跳转到会员中心界面
      router.push({
        path: "/member-center/"
      });
    };
    return {
      authStore,
      startWechatAuth
    };
  }
};